import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {selectUser} from './features/userSlice';
import {selectChannelId, selectChannelName} from './features/appSlice';
import Message from './Message';
import { db } from './firebase';
import firebase from 'firebase';
import ChatHeader from './ChatHeader';
import AddIcon from '@material-ui/icons/Add';
import './Chat.css';

function Chat() {
    const user = useSelector(selectUser);
    const channelId = useSelector(selectChannelId);
    const channelName = useSelector(selectChannelName);
    const [input, setInput] = useState("");
    const [messages, setMessages] = useState([]);

useEffect (() => {
    if (channelId) {
    db.collection("channels")
        .doc(channelId)
        .collection("messages")
        .orderBy('timestamp', 'desc')
        .onSnapshot((snapshot) =>
            setMessages(
            snapshot.docs.map((doc) =>
                doc.data()))
            );
            }
    },[channelId]);

const sendMessage = (e) => {
    e.preventDefault();

    db.collection("channels")
        .doc(channelId)
        .collection('messages').add({
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            message: input,
            user: user,
        });
    setInput("");
}
const handleAddChannel = () => {
    const channelName = prompt("Enter a New channel name");
    
    if(channelName) {
        db.collection("channels").add({
            channelName: channelName,
        });
    }
    };
    return (
        
        
        <div className="chat">
            <ChatHeader channelName={channelName} />
           
        <div className="chat__messages">
            {messages.map((message) => (
                <Message
                timestamp={message.timestamp}
                message={message.message}
                user={message.user}
                />
            ))}
        </div>
        
        <div className="chat__input">
            <form>
                    <div className="chat__inputAdd">
                        <h4>{`Add NEW Channel`}</h4>
                        <AddIcon onClick={handleAddChannel}
                        className="chat__inputAddIcon"/>
                    </div>
                    
                    <input
                    value={input}
                    disabled={!channelName}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder={`Pick Any #Channel from the left, then write your Message HERE`}
                    type='text'/>
                    <button 
                    disabled={!channelName}
                    onClick={sendMessage}
                    className='chat__inputButton'  
                    type='submit'
                    >SEND MESSAGE
                    </button>
                </form>
        </div>
</div>
        
    )
}

export default Chat
